export const WEBLATE_COMPONENT_NAME = 'partner-center/partner-self-signup-client';
export const TERMS_OF_SERVICE_URL = 'https://www.vendasta.com/privacy-policy';
export const PRIVACY_POLICY_URL = 'https://www.vendasta.com/terms/terms-of-service/';
export const GOOGLE_TERMS_OF_SERVICE_URL = 'https://policies.google.com/privacy';
export const GOOGLE_PRIVACY_POLICY_URL = 'https://policies.google.com/terms';
